import React, { useMemo, useState } from 'react';
import {
  Button, Card, Col, Form, Row, Badge,
} from 'react-bootstrap';
import ConfirmModal from '../common/ConfirmModal';
import DownloadLink from '../common/DownloadLink';
import Required from '../Required';
import './styling.less';

export default function UniqueResultDocument({
  file, onFileChange, onFileRemove, canEdit,
}) {
  const [showConfirmFileRemoveModal, setShowConfirmFileRemoveModal] = useState(false);

  const setType = (newType) => {
    onFileChange(file.hash, 'type', newType);
  };

  const setTitle = ({ target }) => {
    onFileChange(file.hash, 'title', target.value);
  };

  const setLink = ({ target }) => {
    onFileChange(file.hash, 'link', target.value);
  };

  const setFile = ({ target }) => {
    const fileToSet = target.files.length ? target.files[0] : null;
    onFileChange(file.hash, 'doc', fileToSet);
  };

  const handleFileRemoveRequest = (confirmed) => {
    if (file.id && !confirmed) {
      setShowConfirmFileRemoveModal(true);
      return;
    }
    onFileRemove(file.id, file.hash);
  };

  const confirmFileRemove = () => {
    handleFileRemoveRequest(true);
    setShowConfirmFileRemoveModal(false);
  };

  const isFileSaved = !!file.id;

  const nameRequired = useMemo(() => file.type === 'link' && file.link || file.type === 'file' && file.file, [file]);

  return (
    <div className="my-3">

      <Row className="mb-4">
        <Form.Group as={Col} md="12">
          <Form.Label>
            Наименование документа
            <Required />
          </Form.Label>
          {(canEdit || !isFileSaved) && <Button onClick={() => handleFileRemoveRequest()} variant="light" className="btn-close ms-3" size="sm" />}
          <Form.Control
            readOnly={isFileSaved}
            required={true}
            as="textarea"
            rows={3}
            value={file.title}
            onChange={setTitle}
            placeholder="Введите наименование документа"
          />
          <Form.Control.Feedback type="invalid">Обязательное поле</Form.Control.Feedback>
        </Form.Group>
      </Row>
      <Row className="mb-4">
        {isFileSaved && (
        <Form.Group as={Col} md="12">
          <Form.Check disabled={isFileSaved} onChange={() => setType('link')} type="radio" id={`radio-link-${file.hash}`} checked={!(file.link == null)} label="Ссылка" inline />
          <Form.Check disabled={isFileSaved} onChange={() => setType('file')} type="radio" id={`radio-file-${file.hash}`} checked={file.link == null} label="Файл" inline />
        </Form.Group>
        )}
        {!isFileSaved && (
        <Form.Group as={Col} md="12">
          <Form.Check disabled={isFileSaved} onChange={() => setType('link')} type="radio" id={`radio-link-${file.hash}`} checked={file.type == 'link'} label="Ссылка" inline />
          <Form.Check disabled={isFileSaved} onChange={() => setType('file')} type="radio" id={`radio-file-${file.hash}`} checked={file.type == 'file'} label="Файл" inline />
        </Form.Group>
        )}
      </Row>
      <Row>
        { !isFileSaved && (
        <>
          {file.type === 'link' && (
          <Form.Group as={Col} md="12">
            <Form.Label>
              Ссылка на отчетный документ в СЭД
              <Required />
              {' '}

            </Form.Label>
            <Form.Control required={true} placeholder="https://" value={file.link} onChange={setLink} />
            <Form.Control.Feedback type="invalid">Обязательное поле</Form.Control.Feedback>
          </Form.Group>
          )}
          {file.type === 'file' && (
          <Form.Group as={Col} md="12">
            <Form.Label>Файл </Form.Label>
            <Form.Control required={true} onChange={setFile} type="file" accept="application/pdf" />
            {/* <Form.Control.Feedback type="invalid">Обязательное поле</Form.Control.Feedback> */}
          </Form.Group>
          )}
        </>
        )}
        {
              isFileSaved && (
              <>
                {!(file.link == null) && (
                <Form.Group as={Col} md="12">
                  <Form.Label>
                    Ссылка на отчетный документ в СЭД
                    <Required />
                    {' '}

                  </Form.Label>
                  <br />
                  <Form.Text><a href={file.link} target="_blank" rel="noreferrer">{file.link}</a></Form.Text>
                </Form.Group>
                )}
                {file.link == null && (
                <Form.Group as={Col} md="12">
                  <Form.Label>Файл </Form.Label>
                  <br />
                  <DownloadLink url={`/files/download/${file.fileId}`} filename={file.fileName}>{file.fileName}</DownloadLink>
                </Form.Group>
                )}
              </>
              )
            }
      </Row>
      <ConfirmModal
        show={showConfirmFileRemoveModal}
        onConfirm={confirmFileRemove}
        onClose={() => setShowConfirmFileRemoveModal(false)}
        message="Файл будет удалён с сервера без возможности восстановления. Вы уверены?"
      />
    </div>
  );
}

const cardHeaderStyling = { display: 'flex', justifyContent: 'end', minHeight: 38 };
